import { render, staticRenderFns } from "./sdkdowBtn.vue?vue&type=template&id=abbb4dd6&scoped=true&"
import script from "./sdkdowBtn.vue?vue&type=script&lang=js&"
export * from "./sdkdowBtn.vue?vue&type=script&lang=js&"
import style0 from "./sdkdowBtn.vue?vue&type=style&index=0&id=abbb4dd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbb4dd6",
  null
  
)

export default component.exports